import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Link } from 'react-router-dom';

const OrderSummary = ({ 
  subtotal, 
  discount, 
  deliveryFee, 
  tax, 
  total, 
  itemCount,
  onProceedToCheckout 
}) => {
  const formatCurrency = (amount) => `$${amount.toFixed(2)}`;

  return (
    <div className="bg-surface border border-border rounded-card p-6 sticky top-20">
      <h3 className="font-heading font-heading-semibold text-xl text-text-primary mb-6">
        Order Summary
      </h3>

      <div className="space-y-4 mb-6">
        {/* Items Count */}
        <div className="flex justify-between items-center">
          <span className="text-text-secondary">Items ({itemCount})</span>
          <span className="font-data font-data-medium">{formatCurrency(subtotal)}</span>
        </div>

        {/* Discount */}
        {discount > 0 && (
          <div className="flex justify-between items-center text-success">
            <div className="flex items-center space-x-2">
              <Icon name="Tag" size={16} />
              <span>Discount</span>
            </div>
            <span className="font-data font-data-medium">-{formatCurrency(discount)}</span>
          </div>
        )}

        {/* Delivery Fee */}
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <Icon name="Truck" size={16} className="text-text-secondary" />
            <span className="text-text-secondary">Delivery</span>
          </div>
          <span className="font-data font-data-medium">
            {deliveryFee === 0 ? 'FREE' : formatCurrency(deliveryFee)}
          </span>
        </div>

        {/* Tax */}
        <div className="flex justify-between items-center">
          <span className="text-text-secondary">Tax</span>
          <span className="font-data font-data-medium">{formatCurrency(tax)}</span>
        </div>

        <div className="border-t border-border pt-4">
          <div className="flex justify-between items-center">
            <span className="font-heading font-heading-semibold text-lg text-text-primary">
              Total
            </span>
            <span className="font-data font-data-medium text-2xl text-primary">
              {formatCurrency(total)}
            </span>
          </div>
        </div>
      </div>

      {/* Delivery Info */}
      <div className="bg-background p-4 rounded-input mb-6">
        <div className="flex items-center space-x-2 mb-2">
          <Icon name="Clock" size={16} className="text-primary" />
          <span className="font-body-semibold text-primary">Free Delivery</span>
        </div>
        <p className="text-sm text-text-secondary">
          On orders over $50. Delivery within 2-4 hours.
        </p>
      </div>

      {/* Action Buttons */}
      <div className="space-y-3">
        <Button
          variant="primary"
          fullWidth
          onClick={onProceedToCheckout}
          iconName="ArrowRight"
          iconPosition="right"
          className="h-12"
        >
          Proceed to Checkout
        </Button>

        <Link to="/product-catalog-category-browse">
          <Button variant="outline" fullWidth className="h-10">
            Continue Shopping
          </Button>
        </Link>
      </div>

      {/* Security Badges */}
      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-center justify-center space-x-4 text-xs text-text-secondary">
          <div className="flex items-center space-x-1">
            <Icon name="Shield" size={14} />
            <span>Secure</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Lock" size={14} />
            <span>SSL Protected</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="CheckCircle" size={14} />
            <span>Verified</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;